const PaymentStatus = {
  PENDING: {
    label: '결제대기',
    title: '결제대기',
    color: 'blue',
  },
  COMPLETED: {
    label: '완료',
    title: '완료',
    color: 'green',
  },
  CANCELLED: {
    label: '취소',
    title: '취소',
    color: 'red',
  },
  FAILED: { label: '결제실패', title: '결제실패', color: 'orange' },

  REFUNDED: {
    label: '환불',
    title: '환불',
    color: 'volcano',
  },
  PARTIALLY_REFUNDED: {
    label: '부분환불',
    title: '부분환불',
    color: 'purple',
  },
};

export default PaymentStatus;
